/**
 * Application version
 * Keep in sync with package.json
 */
export const APP_VERSION = '2.0.0-rc2';
